<template lang="pug">
li.dropdown-item
  a(
    :href="href"
    :disabled="disabled ? 'disabled' : null"
    :data-testid="dataTestId"
    :class="{ 'blank-link': disabled }"
    @click="onClick"
  )
    slot
</template>

<script>
export default {
  name: 'AppDropdownItem',
  inject: {
    // A function returning the tracking context; outside an AppDropdown there is none, so nothing is tracked.
    dropdownTracking: { default: () => () => ({ track: false }) },
  },
  props: {
    href: {
      type: String,
      default: '#',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataTestId: {
      type: String,
      default: null,
    },
    // Event name, defaults to the item text e.g. "Edit client".
    trackAs: {
      type: String,
      default: null,
    },
    track: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['click'],
  methods: {
    trackClick(evt) {
      const { track, props } = this.dropdownTracking();

      if (this.disabled || !this.track || !track) {
        return;
      }

      window.analytics?.track(this.trackAs || evt.currentTarget.textContent.replace(/\s+/g, ' ').trim(), props);
    },
    onClick(evt) {
      try {
        this.trackClick(evt);
      } catch {
        // Analytics failures must not block the action.
      }
      if (!this.disabled && this.href === '#') {
        evt.preventDefault();
        this.$emit('click', evt);
      }
    },
  },
};
</script>
